// extracted by mini-css-extract-plugin
module.exports = {"pagelink":"pagelink_pagelink__2xFPw","labelWrap":"pagelink_labelWrap__25xqq","back":"pagelink_back__32WX6","buttonWrap":"pagelink_buttonWrap__2nfw1"};